import * as mutation from './mutation'
import * as queries from './queries'
import * as subscription from './subscription'
import * as restAPI from './rest'

export const mutate = mutation
export const query = queries
export const sub = subscription
export const rest = restAPI